<template>
  <v-snackbar-queue
    v-model="messages"
    :total-visible="3"
    location="top center"
    transition="bouncy-slide-auto"
    content-class="notification elevation-15"
    prepend-icon="info"
    color="#EEEEEE"
    :content-props="{style: {top: smAndUp ? '4px' : '70px'}}"
    :max-width="maxWidth"
  >
  </v-snackbar-queue>
</template>
<script setup lang="ts">
import {useMessageStore} from '@/stores/messagesStore'
import {storeToRefs} from 'pinia'
import {computed} from 'vue'
import {useDisplay} from 'vuetify'

const {smAndUp, name} = useDisplay()
const messageStore = useMessageStore()
const {messages} = storeToRefs(messageStore)
const maxWidth = computed(() => {
  switch (name.value) {
    case 'xs':
    case 'sm':
      return '328px'
    case 'md':
      return '400px'
    case 'lg':
      return '500px'
    case 'xl':
      return '750px'
    case 'xxl':
      return '1000px'
    default:
      return 'unset'
  }
})
</script>
<style lang="scss">
.notification {
  .v-snackbar__prepend {
    .v-icon {
      color: rgb(var(--v-theme-primary));
    }
  }
}
</style>
